import type { UserRole } from '../types';
import {
  ROUTE_ACCESS,
  canAccessRoute as canAccessRouteFromMatrix,
} from './rolePermissions';

/** @deprecated Use ROUTE_ACCESS from rolePermissions.ts */
export const RESTRICTED_ROUTE_ROLES = ROUTE_ACCESS;

export function normalizeAppPath(pathname: string): string {
  const base = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  if (base.startsWith('/user-profile/')) return '/user-profile';
  return base;
}

export function canAccessRoute(role: UserRole | string | undefined | null, pathname: string): boolean {
  return canAccessRouteFromMatrix(role, pathname);
}

export function rolesForRoute(pathname: string): UserRole[] | null {
  const path = normalizeAppPath(pathname);
  const allowed = ROUTE_ACCESS[path];
  return allowed ? [...allowed] : null;
}
